<template>
    <span class="has-text-warning clarity-mask">
        ({{ translate("audit_logs.log_type.action_made_by", false, [user.firstName, user.lastName]) }})
    </span>
</template>

<script setup lang="ts">
    import { User } from "../../Common/types";
    import { translate } from "../../Common/translations";

    defineProps<{
        user: User;
    }>();
</script>

<style scoped></style>
